/* WildBoard -> Klaviyo form routing.
   Every email input on the site subscribes to the right list BEFORE the native
   Shopify form posts, so Amy still gets the email AND Klaviyo gets the profile
   and fires the right flow. Keyed by form id so no Liquid changes are needed.

   Endpoint is /client/subscriptions/, which IS the consent endpoint: hitting it
   records an explicit email marketing opt-in with source + timestamp. Do not add
   a `subscriptions` block to the profile here, the client endpoint rejects it (400).
   The public company id is designed to ship client-side and is not a secret. */
(function () {
  var COMPANY = 'Szg4iA';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY;
  var REVISION = '2024-10-15';

  /* form id -> where it goes */
  var MAP = {
    'wb-signup-form': {
      list: 'Y9zXDT',
      source: 'Newsletter signup (site footer)'
    },
    'wbct-contact-form': {
      list: 'Y9zXDT',
      source: 'Contact page opt-in',
      optin: 'input[name="contact[Newsletter]"]'
    },
    'wbws-note': {
      list: 'WKR2Lk',
      source: 'Wholesale direct line'
    },
    'wbws-reserve': {
      list: 'VNiWL9',
      source: 'Wholesale waitlist (Faire + Airgoods)'
    }
  };

  /* Klaviyo has real top-level fields for these; everything else rides in properties */
  var TOP = {
    name: 'first_name',
    first_name: 'first_name',
    last_name: 'last_name',
    Phone: 'phone_number',
    phone: 'phone_number',
    Store: 'organization',
    company: 'organization'
  };

  /* `body` is the free-text note (and on the reserve form, a hidden canned string).
     It belongs in the email Amy receives, not as a Klaviyo profile property. */
  var SKIP = { form_type: 1, utf8: 1, 'contact[tags]': 1, 'contact[body]': 1, g: 1 };
  var SKIP_KEY = { body: 1, email: 1 };

  function buildProfile(form) {
    var attrs = { properties: {} };
    var data = new FormData(form);
    data.forEach(function (val, key) {
      if (SKIP[key] || typeof val !== 'string' || !val.trim()) return;
      var m = key.match(/^contact\[(.+)\]$/);
      var k = m ? m[1] : key;
      if (SKIP_KEY[k]) return;
      if (TOP[k]) {
        /* "name" is a full name in our forms: split it so Klaviyo greetings read right */
        if (TOP[k] === 'first_name' && k === 'name' && val.indexOf(' ') > 0) {
          attrs.first_name = val.slice(0, val.indexOf(' ')).trim();
          attrs.last_name = val.slice(val.indexOf(' ') + 1).trim();
        } else {
          attrs[TOP[k]] = val.trim();
        }
      } else {
        attrs.properties[k] = val.trim();
      }
    });
    return attrs;
  }

  function subscribe(form, cfg) {
    var emailEl = form.querySelector('input[type="email"]');
    if (!emailEl || !emailEl.value) return Promise.resolve();

    var attrs = buildProfile(form);
    attrs.email = emailEl.value.trim();
    attrs.properties['Signup source'] = cfg.source;
    attrs.properties['Signup page'] = location.pathname;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.source,
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };

    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    }).catch(function () { /* never block the customer on our analytics */ });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || form.wbKlaviyoSent) return;
    var cfg = MAP[form.id];
    if (!cfg) return;

    /* opt-in gated forms: only subscribe if the box is ticked, but always let the form post */
    if (cfg.optin) {
      var box = form.querySelector(cfg.optin);
      if (!box || !box.checked) return;
    }

    e.preventDefault();
    var released = false;
    function release() {
      if (released) return;
      released = true;
      form.wbKlaviyoSent = true;
      form.submit();
    }
    /* never hold the shopper hostage to Klaviyo being slow */
    setTimeout(release, 1500);
    subscribe(form, cfg).then(release, release);
  }, true);
})();
